import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
          username: string;
          email: string;
          coins: number;
          owned_blocks: string[];
          stock_portfolio: Record<string, unknown>;
          joined_at: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          username: string;
          email: string;
          coins?: number;
          owned_blocks?: string[];
          stock_portfolio?: Record<string, unknown>;
          joined_at?: string;
        };
        Update: {
          username?: string;
          coins?: number;
          owned_blocks?: string[];
          stock_portfolio?: Record<string, unknown>;
          updated_at?: string;
        };
      };
    };
  };
};
